import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
/* https://devdocs.magento.com/guides/v2.4/graphql/mutations/create-wishlist.html */

export var CREATE_WISHLIST = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation createWishlist(\n        $name: String!\n        $visibility: WishlistVisibilityEnum!\n    ) {\n        createWishlist(input: { name: $name, visibility: $visibility }) {\n            wishlist {\n                id\n            }\n        }\n    }\n"])));
export default {
  createWishlistMutation: CREATE_WISHLIST
};